import { render, staticRenderFns } from "./AdminBody.vue?vue&type=template&id=1cac7e28&scoped=true&"
import script from "./AdminBody.vue?vue&type=script&lang=js&"
export * from "./AdminBody.vue?vue&type=script&lang=js&"
import style0 from "./AdminBody.vue?vue&type=style&index=0&id=1cac7e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cac7e28",
  null
  
)

component.options.__file = "AdminBody.vue"
export default component.exports